import { render, staticRenderFns } from "./SportsTeam.vue?vue&type=template&id=b916dcda&scoped=true"
import script from "./SportsTeam.vue?vue&type=script&lang=js"
export * from "./SportsTeam.vue?vue&type=script&lang=js"
import style0 from "./SportsTeam.vue?vue&type=style&index=0&id=b916dcda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b916dcda",
  null
  
)

export default component.exports